import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { BukTicketSenderInfo } from '../models/buk-ticket.model';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  constructor(private http: HttpClient) {}

  getSenderInfo(id: string): Observable<BukTicketSenderInfo> {
    return this.http.get<BukTicketSenderInfo>(
      `${environment.apiEndpoint}/tickets/sender_info/${id}`,
      {
        withCredentials: true,
      }
    );
  }
}
